module.exports = __webpack_public_path__ + "media/images/landing/bg/case-emco/instagram-2-87ea3be85dd04ea10346a70d853d1294.jpg";